"use client";

import { scrollToTop } from "@homeinstead/shared";
import { NavigationBarLayout } from "~care/components/app/landing/Navigation";
import PhoneLink from "~care/components/app/landing/PhoneLink/PhoneLink";
import { Button } from "~care/components/ui/Button/Button";
import ContactIcon from "~care/components/ui/Icons/ui/contact-icon.svg";
import { NavigationPhoneCTA } from "~care/components/ui/NavigationMenu/PPC/NavigationPhoneCTA";
import { shallowStrings } from "~care/components/ui/NavigationMenu/PPC/navigation-strings";
import { INVOCA_PHONE_NUMBER } from "~care/lib/constants/phone-numbers";
import { formatPartialPhoneNumber } from "~care/lib/utils/phone/phone";

interface RPNPhoneCTAProps {
  phoneNumber: string;
  ctaText: string;
}

export function RPNPhoneCTA({ phoneNumber, ctaText }: RPNPhoneCTAProps) {
  return (
    <>
      <PhoneLink
        className="px-2 sm:hidden sm:px-4"
        phoneNumber={phoneNumber}
        placement="header"
        variant="friendly"
      >
        {ctaText}
      </PhoneLink>

      <Button
        className="hidden px-2 sm:block sm:px-4"
        onClick={scrollToTop}
        variant="friendly"
      >
        {ctaText}
      </Button>
    </>
  );
}

interface RPNDesktopCTAProps {
  phoneNumber: string;
  formattedPhoneNumber: string;
  ctaLabel: string;
}

export function RPNDesktopCTA({
  phoneNumber,
  formattedPhoneNumber,
  ctaLabel,
}: RPNDesktopCTAProps) {
  return (
    <div className="me-6 flex h-12 items-center gap-3 xl:me-0">
      <ContactIcon className="min-w-6" />
      <div>
        <span>{shallowStrings.openCallUsNow} &nbsp;</span>
        <PhoneLink
          className="inline-block h-fit p-0"
          phoneNumber={phoneNumber}
          placement="header"
        >
          {formattedPhoneNumber}
        </PhoneLink>
      </div>
      <RPNPhoneCTA ctaText={ctaLabel} phoneNumber={phoneNumber} />
    </div>
  );
}

interface RPNMobileCTAProps {
  phoneNumber: string;
  formattedPhoneNumber: string;
}

export function RPNMobileCTA({
  phoneNumber,
  formattedPhoneNumber,
}: RPNMobileCTAProps) {
  return (
    <div className="me-5 flex h-12 items-center gap-3 xl:me-0">
      <NavigationPhoneCTA
        formattedPhoneNumber={formattedPhoneNumber}
        phoneNumber={phoneNumber}
      />
    </div>
  );
}

interface NavigationRPNProps {
  containerClassName?: string;
  ctaLabel: string;
  phoneNumber?: string;
}

export default function NavigationRPN({
  containerClassName,
  ctaLabel,
  phoneNumber = INVOCA_PHONE_NUMBER,
}: NavigationRPNProps) {
  const formattedPhoneNumber = formatPartialPhoneNumber({
    franchisePhone: phoneNumber,
  });

  return (
    <NavigationBarLayout
      containerClassName={containerClassName}
      desktopCTA={
        <RPNDesktopCTA
          ctaLabel={ctaLabel}
          formattedPhoneNumber={formattedPhoneNumber}
          phoneNumber={phoneNumber}
        />
      }
      mobileCTA={
        <RPNMobileCTA
          formattedPhoneNumber={formattedPhoneNumber}
          phoneNumber={phoneNumber}
        />
      }
    />
  );
}
